<template>
  <div class="editItems">
    <v-container class="my-5">
      <v-row justify="center">
        <v-col cols="6">
          <ScanItem @foundItem="foundItem" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <MassEditItemsTable v-if="!editMode" :propScannedItems="scannedItems" @editMode="editMode = !editMode" @selectedItems="emittedSelectedItems" @clearTable="clearTable" />
          <MassEditItems v-if="editMode" :propItems="selectedItems" @editMode="editMode = !editMode" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ScanItem from '@/components/ScanItem'
import MassEditItemsTable from '@/components/MassEditItemsTable'
import MassEditItems from '@/components/MassEditItems'

export default {
  name: 'Item',

  components: {
    ScanItem,
    MassEditItemsTable,
    MassEditItems
  },

  data: () => ({
    scannedItems: [],
    scanItemErrorMessage: '',
    editMode: false,
    selectedItems: []
  }),

  methods: {
    foundItem (foundItem) {
      console.log('found item:', foundItem)
      if (!this.scannedItems.find(item => { return item.id === foundItem.id })) {
        this.scannedItems.push(foundItem)
      } else {
        console.log('Item already in table')
        this.$store.commit('setSnackbarText', 'Item already in table')
        this.$store.commit('setSnackbarColor', 'warning')
        this.$store.commit('setSnackbar', true)
      }
    },

    emittedSelectedItems (selectedItems) {
      this.selectedItems = selectedItems
    },

    clearTable () {
      this.scannedItems = []
      this.selectedItems = []
    }
  }
}
</script>
